<template>
  <v-container
    fluid
    tile
    class="pa-0"
    :style="'background-color: ' + this.webTheme.colors.content.hexa + ';'"
  >
    <v-row no-gutters justify="center">
      <v-col xs="12" :sm="component.settings.cols">
        <v-sheet tile :color="this.webTheme.colors.content.hexa" :style="block">
          <v-row no-gutters justify="center">
            <v-col>
              <view-text :settings="component.title"></view-text>
            </v-col>
          </v-row>
          <v-row
            v-for="(category, id) in rewardCategories"
            :key="id"
            no-gutters
          >
            <v-col>
              <v-row no-gutters>
                <view-text
                  :settings="component.category"
                  :value="category.title"
                ></view-text>
              </v-row>

              <v-row
                v-if="component.card.group.slider === 'slide'"
                no-gutters
                :justify="component.card.group.justify"
              >
                <v-col :lg="component.card.group.cols">
                  <v-card
                    tile
                    elevation="0"
                    :class="grid.inner"
                    background-color="transparent"
                  >
                    <v-slide-group
                      :dark="component.card.group.dark"
                      show-arrows="always"
                    >
                      <v-slide-item
                        v-for="(card, i) in category.rewardList"
                        :key="i"
                      >
                        <v-card
                          :class="classes"
                          :style="styles + ';' + gradient"
                          :height="cardHeight"
                          :width="component.card.width"
                          :elevation="component.card.elevation"
                          @click="openRewardPopUp(card)"
                        >
                          <v-img
                            v-if="component.image.show === true"
                            :height="component.image.height + 'px'"
                            :lazy-src="
                              card.externalImageUrl
                                ? card.externalImageUrl
                                : card.image.mediumUrl
                            "
                            :src="
                              card.externalImageUrl
                                ? card.externalImageUrl
                                : card.image.mediumUrl
                            "
                            :class="card.radius ? 'radius' : ''"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>

                          <v-card-text :style="cardText">
                            <v-row no-gutters v-if="card.title">
                              <v-col>
                                <view-text
                                  :settings="component.heading"
                                  :value="card.title"
                                />
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <view-text
                                  :settings="component.points"
                                  :value="
                                    formatPoints(card.points) +
                                      ' ' +
                                      pointsLabel
                                  "
                                />
                              </v-col>
                            </v-row>
                            <v-row
                              no-gutters
                              v-if="
                                card.body && component.settings.previewRows > 0
                              "
                            >
                              <v-col>
                                <view-text
                                  :settings="component.body"
                                  :value="card.body"
                                  :lines="component.settings.previewRows"
                                />
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-slide-item>
                    </v-slide-group>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else no-gutters :justify="component.card.group.justify">
                <v-col :lg="component.card.group.cols">
                  <v-card tile elevation="0" :class="grid.inner">
                    <v-row
                      class="mx-2 mx-lg-0"
                      :justify="component.card.group.justify"
                    >
                      <v-card
                        v-for="(card, i) in category.rewardList"
                        :key="i"
                        :class="classes"
                        :height="component.card.height"
                        :width="component.card.width"
                        :style="styles + ';' + gradient"
                        :elevation="component.card.elevation"
                        @click="openRewardPopUp(card)"
                      >
                        <v-img
                          v-if="component.image.show === true"
                          :height="component.image.height + 'px'"
                          :lazy-src="
                            card.externalImageUrl
                              ? card.externalImageUrl
                              : card.image.mediumUrl
                          "
                          :src="
                            card.externalImageUrl
                              ? card.externalImageUrl
                              : card.image.mediumUrl
                          "
                          :class="card.radius ? 'radius' : ''"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>

                        <div>
                          <v-row no-gutters v-if="card.title">
                            <v-col>
                              <view-text
                                :settings="component.heading"
                                :value="card.title"
                              />
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col>
                              <view-text
                                :settings="component.points"
                                :value="
                                  formatPoints(card.points) + ' ' + pointsLabel
                                "
                              />
                            </v-col>
                          </v-row>
                          <v-row no-gutters v-if="card.body">
                            <v-col>
                              <view-text
                                :settings="component.body"
                                :value="card.body"
                                :lines="component.settings.previewRows"
                              />
                            </v-col>
                          </v-row>
                        </div>
                      </v-card>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>

    <reward-dialog
      v-if="showReward"
      :is-visible="showReward"
      :on-close="closeRewardPopUp"
      :reward="activeReward"
      :component="component"
    ></reward-dialog>
  </v-container>
</template>

<script>
import numeral from "numeral";
import ViewText from "../Text.vue";
import RewardDialog from "./RewardDialog.vue";

export default {
  components: {
    ViewText,
    RewardDialog
  },
  props: ["component"],
  async created() {
    // Load reward catalogue data based on route parameter
    await this.loadRewardCatalogueData();
  },
  data: function() {
    return {
      showReward: false,
      activeReward: {},
      rewardCategories: []
    };
  },
  computed: {
    pointsLabel() {
      return this.$store.getters.currentProgram.points.label;
    },
    cardHeight() {
      if (this.component.card.autoHeight === true) {
        return "auto";
      }
      return this.component.card.height;
    },
    primary() {
      return this.webTheme.colors.primary.hex;
    },
    classes() {
      var classes = this.component.card.rounded;
      return classes;
    },
    grid() {
      return this.$store.getters.grid;
    },
    block() {
      var padding = this.component.block.padding;
      return (
        this.grid.block +
        "px ;" +
        "padding-left: " +
        padding.left +
        "px ;" +
        "padding-right: " +
        padding.right +
        "px ;" +
        "padding-top: " +
        padding.top +
        "px ;" +
        "padding-bottom: " +
        padding.bottom +
        "px ;"
      );
    },
    cardText() {
      var padding = this.component.card.textAreaPadding;
      return (
        "padding-left: " +
        padding.left +
        "px ;" +
        "padding-right: " +
        padding.right +
        "px ;" +
        "padding-top: " +
        padding.top +
        "px ;" +
        "padding-bottom: " +
        padding.bottom +
        "px ;"
      );
    },
    gradient() {
      if (this.component.card.color.type === "gradient") {
        var color = this.component.card.color;
        var gradient =
          "background: linear-gradient(" +
          color.direction +
          ", rgba(" +
          color.gradientFrom.rgba.r +
          ", " +
          color.gradientFrom.rgba.g +
          ", " +
          color.gradientFrom.rgba.b +
          ", " +
          color.gradientFrom.rgba.a +
          ") " +
          ", rgba(" +
          color.gradientTo.rgba.r +
          ", " +
          color.gradientTo.rgba.g +
          ", " +
          color.gradientTo.rgba.b +
          ", " +
          color.gradientTo.rgba.a +
          ")" +
          color.gradientHeight +
          "%)";
        return gradient;
        // return 'background: linear-gradient(to top, rgba(0, 0, 255, 100), rgba(255, 0, 0, 100) 50%)'
      } else {
        return "background: " + this.component.card.color.solidColor.hexa + ";";
      }
    },
    styles() {
      var styles =
        "margin-bottom: " +
        this.component.card.margin.bottom +
        "px ;" +
        "margin-top: " +
        this.component.card.margin.top +
        "px ;" +
        "margin-left: " +
        this.component.card.margin.left +
        "px ;" +
        "margin-right: " +
        this.component.card.margin.right +
        "px ;" +
        "padding-bottom: " +
        this.component.card.padding.bottom +
        "px ;" +
        "padding-top: " +
        this.component.card.padding.top +
        "px ;" +
        "padding-left: " +
        this.component.card.padding.left +
        "px ;" +
        "padding-right: " +
        this.component.card.padding.right +
        "px ;" +
        "border: " +
        this.component.card.borderSize +
        "px solid " +
        this.component.card.borderColor.hexa +
        "; ";
      return styles;
    },
    webTheme() {
      return this.$store.getters.currentProgram.webTheme;
    },
    // Unique to member website
    primaryMenus() {
      return this.$store.getters.primaryMenus;
    },
    screenDetail() {
      return (
        this.primaryMenus.find(
          menuDetail => menuDetail.content === this.$route.params.id
        ) || {}
      );
    }
  },
  watch: {
    "$route.params.id": {
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.loadRewardCatalogueData();
        }
      },
      immediate: false
    }
  },
  mounted() {
    // Component is mounted, data loading is handled in created()
  },
  methods: {
    openRewardPopUp(value) {
      this.activeReward = value;
      this.showReward = true;
    },
    closeRewardPopUp() {
      this.showReward = false;
    },
    formatPoints(val) {
      return numeral(val).format("0,0");
    },
    async loadRewardCatalogueData() {
      try {
        const catalogueId = this.$route.params.id;
        if (!catalogueId) {
          console.warn("No reward catalogue ID found in route params");
          return;
        }

        // Import Firebase functions
        const { db } = await import("@/firebase");
        const {
          doc,
          getDoc,
          collection,
          query,
          where,
          orderBy,
          getDocs
        } = await import("firebase/firestore");

        const programId = this.$store.getters.programId;
        const programRef = doc(db(), "programs", programId);
        const cataloguesRef = collection(programRef, "rewardCatalogues");
        const catalogueRef = doc(cataloguesRef, catalogueId);

        // Get the specific reward catalogue document
        const catalogueDoc = await getDoc(catalogueRef);

        if (!catalogueDoc.exists()) {
          console.warn("Reward catalogue document not found:", catalogueId);
          this.rewardCategories = [];
          return;
        }

        const catalogueData = catalogueDoc.data();

        // Get current user for tag filtering
        const currentUser = this.$store.getters.currentUser;

        // Check member tag filtering
        let memberTagMatch = false;
        if (
          !catalogueData.memberTags ||
          catalogueData.memberTags.length === 0
        ) {
          memberTagMatch = true;
        } else {
          memberTagMatch = catalogueData.memberTags.some(
            tag => currentUser.tags && currentUser.tags.includes(tag)
          );
        }

        // Check company tag filtering
        let companyTagMatch = false;
        if (
          !catalogueData.companyTags ||
          catalogueData.companyTags.length === 0
        ) {
          companyTagMatch = true;
        } else {
          companyTagMatch = catalogueData.companyTags.some(
            tag =>
              currentUser.companyTags && currentUser.companyTags.includes(tag)
          );
        }

        // If user doesn't have required tags, show empty state
        if (!memberTagMatch || !companyTagMatch) {
          console.warn(
            "Rewards: User does not have required tags to view this catalogue"
          );
          this.rewardCategories = [];
          return;
        }

        try {
          // Get rewards from the program level collection, filtered by reward catalogue ID
          const { onSnapshot } = await import("firebase/firestore");

          const rewardsRef = collection(programRef, "rewards");

          const unsubscribe = onSnapshot(
            query(
              rewardsRef,
              where("status", "==", "Active"),
              where("rewardCatalogue", "==", catalogueId),
              orderBy("updated", "desc")
            ),
            async rewardsSnapshot => {
              const rewardsByCategory = {};
              const categoryTitles = {};

              // First, get all reward categories to get their titles
              const categoriesRef = collection(programRef, "rewardCategories");
              const categoriesSnapshot = await getDocs(categoriesRef);

              categoriesSnapshot.forEach(categoryDoc => {
                const categoryData = categoryDoc.data();
                categoryTitles[categoryDoc.id] =
                  categoryData.title || "Rewards";
              });

              // Process each reward and group by categories
              rewardsSnapshot.forEach(rewardDoc => {
                const rewardData = rewardDoc.data();

                // Check individual reward member tag filtering
                let rewardMemberTagMatch = false;
                if (
                  !rewardData.memberTags ||
                  rewardData.memberTags.length === 0
                ) {
                  rewardMemberTagMatch = true;
                } else {
                  rewardMemberTagMatch = rewardData.memberTags.some(
                    tag => currentUser.tags && currentUser.tags.includes(tag)
                  );
                }

                // Check individual reward company tag filtering
                let rewardCompanyTagMatch = false;
                if (
                  !rewardData.companyTags ||
                  rewardData.companyTags.length === 0
                ) {
                  rewardCompanyTagMatch = true;
                } else {
                  rewardCompanyTagMatch = rewardData.companyTags.some(
                    tag =>
                      currentUser.companyTags &&
                      currentUser.companyTags.includes(tag)
                  );
                }

                // Skip this reward if user doesn't have required tags
                if (!rewardMemberTagMatch || !rewardCompanyTagMatch) {
                  return;
                }

                const reward = {
                  id: rewardDoc.id,
                  ...rewardData,
                  updated: rewardData.updated?.toDate() || new Date(),
                  created: rewardData.created?.toDate() || new Date()
                };

                // Add this reward to each of its categories
                if (
                  rewardData.rewardCategories &&
                  Array.isArray(rewardData.rewardCategories)
                ) {
                  rewardData.rewardCategories.forEach(categoryId => {
                    if (!rewardsByCategory[categoryId]) {
                      rewardsByCategory[categoryId] = [];
                    }
                    rewardsByCategory[categoryId].push(reward);
                  });
                }
              });

              // Sort rewards within each category by sortOrder
              Object.keys(rewardsByCategory).forEach(categoryId => {
                rewardsByCategory[categoryId].sort((a, b) => {
                  // Handle legacy rewards without sortOrder gracefully
                  const sortOrderA =
                    a.sortOrder !== undefined ? a.sortOrder : 999999;
                  const sortOrderB =
                    b.sortOrder !== undefined ? b.sortOrder : 999999;

                  // Primary sort by sortOrder (ascending)
                  if (sortOrderA !== sortOrderB) {
                    return sortOrderA - sortOrderB;
                  }

                  // Secondary sort by updated date (descending) for ties or legacy items
                  return new Date(b.updated) - new Date(a.updated);
                });
              });

              // Convert to the format expected by the template
              const rewardCategoriesList = Object.keys(rewardsByCategory).map(
                categoryId => ({
                  id: categoryId,
                  title: categoryTitles[categoryId] || "Rewards",
                  rewardList: rewardsByCategory[categoryId]
                })
              );

              this.rewardCategories = rewardCategoriesList;

              // Clean up the listener
              if (unsubscribe) {
                unsubscribe();
              }
            },
            error => {
              console.warn(
                "Rewards: Cannot load rewards, showing placeholder:",
                error.message
              );

              // Show placeholder when rewards can't be loaded
              this.rewardCategories = [
                {
                  id: "placeholder",
                  title: catalogueData.title || "Rewards",
                  rewardList: [
                    {
                      id: "placeholder",
                      title: "Rewards Coming Soon",
                      body:
                        "Rewards will be available here soon. Please check back later.",
                      points: 0,
                      image: { mediumUrl: "" },
                      updated: new Date()
                    }
                  ]
                }
              ];
            }
          );
        } catch (rewardsError) {
          console.warn(
            "Rewards: Cannot load rewards due to permissions, showing placeholder:",
            rewardsError.message
          );

          // Show placeholder when rewards can't be loaded
          this.rewardCategories = [
            {
              id: "placeholder",
              title: catalogueData.title || "Rewards",
              rewardList: [
                {
                  id: "placeholder",
                  title: "Rewards Coming Soon",
                  body:
                    "Rewards will be available here soon. Please check back later.",
                  points: 0,
                  image: { mediumUrl: "" },
                  updated: new Date()
                }
              ]
            }
          ];
        }
      } catch (error) {
        console.error("Error loading reward catalogue data:", error);
        // Show error placeholder
        this.rewardCategories = [
          {
            id: "error",
            title: "Rewards",
            rewardList: [
              {
                id: "error",
                title: "Unable to Load Rewards",
                body:
                  "There was an error loading rewards. Please try again later.",
                points: 0,
                image: { mediumUrl: "" },
                updated: new Date()
              }
            ]
          }
        ];
      }
    }
  }
};
</script>

<style scoped>
.radius {
  border-radius: 15px !important;
}
</style>
